import "./MaintenanceHeader.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { useMaintenanceHook } from "../../hooks/maintenanceHook";

interface HeaderProps {
    title?: string;
    hideLoginButton?: boolean;
}

const MaintenanceHeader = ({ title, hideLoginButton }: HeaderProps) => {
    const { isMaintenance, startDate, endDate } = useMaintenanceHook();

    return (
        <>
            {isMaintenance && startDate && endDate && (
            <div className="m-container">
                <div className="m-header-inner-container">
                    <div className="m-header-content">
                        <FontAwesomeIcon className="warning m-icon-sm" icon={faWarning} />
                    </div>
                    <p>
                        Please note The City of Cape Town will be conducting maintenance on their data centres. This maintenance will affect the processing of traffic fines between our systems and the CoCT. The impact will begin at {startDate}, and last until {endDate}.
                    </p>
                </div>
            </div>
        )}
        </>
    );
};

export default MaintenanceHeader;
